import React, { useEffect, useState, useMemo } from "react";
import "./OrderReview.css";
import { Row, Col, Container } from "react-bootstrap";
import Vector from "../../assets/Icons/PNG/Vector.png";

const OrderReview = ({
  formData,
  selectedMedicalCanvassOptions,
  selectedSocialCanvassOption,
  selectedRecordsRequestOption,
  uploadedFiles,
  selectedLocations,
  onOrderViewModel,
}) => {
  const [fileRecords, setFileRecords] = useState([]);
  const userSelectedLocations = selectedLocations.filter(loc => loc.isSelected)

  const fileToFileRecordDTO = async (file) => {
    const reader = new FileReader();
    const arrayBufferPromise = new Promise((resolve, reject) => {
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
    reader.readAsArrayBuffer(file);
    const arrayBuffer = await arrayBufferPromise;

    const byteArray = new Uint8Array(arrayBuffer);

    return {
      FileName: file.name,
      NewFileName: file.name,
      FileSize: file.size,
      ContentType: file.type,
      FileDate: Array.from(byteArray),
    };
  };

  useEffect(() => {
    processFiles();
  }, [uploadedFiles]);

  const processFiles = async () => {
    let files = [];

    uploadedFiles?.recordsRequest && files.push(uploadedFiles?.recordsRequest);

    files =
      uploadedFiles?.claimantInfo?.length > 0
        ? files.concat(uploadedFiles?.claimantInfo)
        : files;

    files =
      uploadedFiles?.locationFile?.length > 0
        ? files.concat(uploadedFiles?.locationFile)
        : files;

    files
      ? setFileRecords(await Promise.all(files.map(fileToFileRecordDTO)))
      : setFileRecords(null);
  };

  const getFormattedDate = (date) => {
    if (date instanceof Date && !isNaN(date))
      return date.toLocaleDateString()
    else return ""
  }
  
  // Get Search Params
  const searchParams = new URLSearchParams(window.location.search.toLowerCase())

  const formattedDateOfBirth = getFormattedDate(formData.claimantInformation.DateBirth)

  const formattedDateOfIncident = getFormattedDate(formData.claimantInformation.DateIncident)

  const formattedDateOfLastWorked = getFormattedDate(formData.claimantInformation.LastWorked)

  const formattedDueDate = getFormattedDate(formData.claimantInformation.DueDate)

  const orderViewModel = useMemo(() => {
    const isLocationSelected = (title, isAlsoQuickTel = true) => {
      let isLocSelected = false;

      if (isAlsoQuickTel) {
        isLocSelected =
          (selectedMedicalCanvassOptions?.some((opt) => opt.id === 1) ||
            selectedMedicalCanvassOptions?.some((opt) => opt.id === 0)) &&
          selectedLocations.some(
            (loc) => loc.title === title && loc.isSelected
          );
      } else {
        isLocSelected =
          selectedMedicalCanvassOptions?.some((opt) => opt.id === 1) &&
          selectedLocations.some(
            (loc) => loc.title === title && loc.isSelected
          );
      }
      return isLocSelected;
    };

    return {
      quickTELRequest: selectedMedicalCanvassOptions?.some((opt) => opt.id === 0),
      retrieveRecords: selectedRecordsRequestOption?.id === 3,
      optiCheckPlus: selectedSocialCanvassOption?.id === 5,
      hospitalCheck: isLocationSelected("Hospital", false),
      pharmacyCheck: isLocationSelected("Pharmacy", false),
      healthClinicCheck: isLocationSelected("Health Clinic (Urgent Care)"),
      chiropracticCheck: isLocationSelected("Chiropractic"),
      doctorCheck: isLocationSelected("Doctor"),
      xRayMRICheck: isLocationSelected("X-Ray / MRI"),
      orthopedicCheck: isLocationSelected("Orthopedic"),
      dentalCheck: isLocationSelected("Dental"),
      clinicalLaboratoriesCheck: isLocationSelected("Clinical Laboratories"),
      neurologyCheck: isLocationSelected("Neurology"),
      cardiologyCheck: isLocationSelected("Cardiology"),
      optometryCheck: isLocationSelected("Optometry / Ophthalmology"),
      podiatryCheck: isLocationSelected("Podiatry"),
      earNoseThroatCheck: isLocationSelected("Ear, Nose, Throat"),
      physicalTherapyCheck: isLocationSelected("Physical Therapy"),
      painManagementCheck: isLocationSelected("Pain Management"),
      mailOrderPharmacyCheck: isLocationSelected("Mail Order Pharmacy"),
      gymCheck: isLocationSelected("Gym"),
      PsychologyCheck: isLocationSelected("Psychology"),
      PsychiatricCheck: isLocationSelected("Psychiatric"),
      other: isLocationSelected("Other (Explain Below)"),
      otherMedicalCanvasses: isLocationSelected("Other (Explain Below)")
        ? formData.medicalCanvassing.other
        : "",
      clientName: formData.requestorInformation.name,
      clientCompany: formData.requestorInformation.company,
      email: formData.requestorInformation.email,
      clientTitle: formData.requestorInformation.title,
      clientAddress: formData.requestorInformation.address,
      clientCity: formData.requestorInformation.city,
      clientState: formData.requestorInformation.state,
      clientZip: formData.requestorInformation.zip,
      clientPhone: formData.requestorInformation.phoneNumber,
      clientClaimNum: formData.requestorInformation.claimNumber,
      clientInsured: formData.requestorInformation.insuredClient,
      clientBPhone: formData.requestorInformation.billToPhone,
      clientBEmail: formData.requestorInformation.billToEmail,
      clientOther: formData.requestorInformation.other,
      ClaimantFirstName: formData.claimantInformation.ClaimantFirstName,
      ClaimantLastName: formData.claimantInformation.ClaimantLastName,
      claimantAlias: formData.claimantInformation.Alias,
      eSSN: formData.claimantInformation.SSN?.replaceAll("-", ""),
      eDOB: formattedDateOfBirth,
      claimantAddress: formData.claimantInformation.ClaimantAddress,
      claimantCity: formData.claimantInformation.city,
      claimantState: formData.claimantInformation.state,
      claimantZip: formData.claimantInformation.zip,
      claimantEmailAddress: formData.claimantInformation.ClaimantEmail,
      claimantPhone: formData.claimantInformation.Phone,
      claimantEmployer: formData.claimantInformation.EmployerName,
      claimantEAddress: formData.claimantInformation.EmployerAddress,
      claimantECity: formData.claimantInformation.EmployerCity,
      claimantEState: formData.claimantInformation.EmployerState,
      claimantEZip: formData.claimantInformation.EmployerZip,
      claimantEPhone: formData.claimantInformation.EmployerPhone,
      claimantContact: formData.claimantInformation.EmployerContactName,
      claimantPosition: formData.claimantInformation.ClaimantPosition,
      claimantDOI: formattedDateOfIncident,
      claimantLast: formattedDateOfLastWorked,
      claimantInjury: formData.claimantInformation.Nature,
      claimantComments: formData.claimantInformation.AdditionalComments,
      clientCoverage: formData.claimantInformation.CoverageType,
      dueDate: formattedDueDate,
      fileRecords: fileRecords,
      OntellusRequest: searchParams.get("o") == "1"
    };
  }, [
    selectedMedicalCanvassOptions,
    selectedRecordsRequestOption,
    selectedSocialCanvassOption,
    formData,
    fileRecords,
    selectedLocations,
  ]);

  useEffect(() => {
    if (onOrderViewModel) {
      onOrderViewModel(orderViewModel);
    }
  }, [orderViewModel, onOrderViewModel]);

  return (
    <div className="order-review">
      <h1 className="txt-orange">Order Review</h1>
      <p className="p-style">
        Review your order details and then click the "Submit Order" button to
        process your order.
      </p>
      <div className="section">
        <div className="section-content">
          <h2>Medical Canvassing</h2>

          <div className="column">
            {selectedMedicalCanvassOptions?.sort((a, b) => a.id - b.id).map(opt => 
              <div>
                <p>
                  <strong className="txt-orange">
                    {opt.title}
                  </strong>
                </p>
                {
                  opt.features &&
                  <p>
                    {opt.features.map((feature, index) => (
                      <React.Fragment key={index}>
                        {feature.title} <br />
                      </React.Fragment>
                    ))}
                  </p>
                }
              </div>
            )}
            
            {userSelectedLocations.length > 0 && selectedMedicalCanvassOptions?.some((opt) => opt.id !== 2) && (
              <div className="mt-2">
                <p>
                  <strong className="txt-orange">
                    Selected Provider Location Types
                  </strong>
                </p>
                <Container>
                  <Row>
                    {userSelectedLocations.map((location) => (
                      location.id === 21 ? <Col key={location.id} md={12} className="px-0">
                        <p>- Other ({formData?.medicalCanvassing?.other})</p>
                      </Col>
                      :
                      <Col key={location.id} md={6} className="px-0">
                        <p>- {location.title}</p>
                      </Col>
                  ))}
                  </Row>
                </Container>
              </div>
            )}
            {uploadedFiles?.locationFile?.length > 0 &&
              <div className="mt-2">
                <p>
                  <strong>Attached file(s):</strong>
                </p>
                <ul>
                  {uploadedFiles?.locationFile?.map((file, index) => <li key={index}>{file.name}</li>)}
                </ul>
              </div>
            }
          </div>
        </div>
      </div>
      <div className="secondSection ">
        <div className="secondSection-content">
          <h2>Records Request</h2>
          <div className="column">
            <p>
              <strong className="txt-orange">
                {selectedRecordsRequestOption.title}
              </strong>
            </p>
            {selectedRecordsRequestOption.id !== 4 && (
              <p>
                <strong>Attached file:</strong>
                <br />
                {uploadedFiles?.recordsRequest
                  ? uploadedFiles?.recordsRequest?.name
                  : "No File Uploaded"}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="section">
        <div className="section-content">
          <h2>Social Canvassing</h2>
          <div className="column">
            <p>
              <strong className="txt-orange p-style">
                {selectedSocialCanvassOption.title}
              </strong>
            </p>
            {selectedSocialCanvassOption.id !== 7 && (
              <p>
                {selectedSocialCanvassOption.features
                  .filter((f) => !f.isDisabled)
                  .map((feature, index) => (
                    <React.Fragment key={index}>
                      {feature.title} <br />
                    </React.Fragment>
                  ))}
              </p>
            )}
          </div>
        </div>
      </div>
      <div>
        <Container
          fluid
          style={{ backgroundColor: "#e0e1e2", padding: "20px" }}
        >
          <Row>
            <Col>
              {" "}
              <h2 className="h2-style">Requestor Information</h2>{" "}
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col>
              <div>
                <p>
                  <strong>Name:</strong> {formData.requestorInformation.name}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>
                <p>
                  <strong>Company:</strong>{" "}
                  {formData.requestorInformation.company}
                </p>
                <p>
                  <strong>Bill to Address:</strong>{" "}
                  {formData.requestorInformation.address}
                </p>
              </div>
            </Col>
            <Col>
            <div>
            <p>
                  <strong>Email:</strong> {formData.requestorInformation.email}
                </p>
                <p>
                  <strong>Title:</strong> {formData.requestorInformation.title}
                </p>
            </div>
            </Col>
               </Row>
               <Row>
                <Col>
                <p>
                  <strong>City:</strong> {formData.requestorInformation.city}
                </p>
                </Col>
                <Col>
                <Row>
                  <Col>
                  <p>
                  <strong>State:</strong> {formData.requestorInformation.state}
                </p>
                  </Col>
                  <Col>
                  <p>
                  <strong>Zip:</strong> {formData.requestorInformation.zip}
                </p>
                  </Col>
                </Row>
                </Col>
                </Row>
                <Row>
            <Col>
              <div>
                <p>
                  <strong>Phone:</strong>{" "}
                  {formData.requestorInformation.phoneNumber}
                </p>
                <p>
                  <strong>Insured/Client:</strong>{" "}
                  {formData.requestorInformation.insuredClient}
                </p>
                <p>
                  <strong>Billing Email:</strong>{" "}
                  {formData.requestorInformation.billToEmail}
                </p>
              
              </div>
            </Col>
            <Col>
              <div>
                <p>
                  <strong>Claim#:</strong>{" "}
                  {formData.requestorInformation.claimNumber}
                </p>
                <p>
                  <strong>Billing Phone:</strong>{" "}
                  {formData.requestorInformation.billToPhone}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>
                <p>
                  <strong>Other:</strong> {formData.requestorInformation.other}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div>
        <Container
          fluid
          style={{ backgroundColor: "#f9f9f9", padding: "20px" }}
        >
          <Row>
            <Col>
              {" "}
              <h2 className="h2-style">Claimant Information</h2>{" "}
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col>
              <div>
                <p>
                  <strong>Claimant First Name:</strong>{" "}
                  {formData.claimantInformation.ClaimantFirstName}
                </p>
                <p>
                  <strong>Claimant Last Name:</strong>{" "}
                  {formData.claimantInformation.ClaimantLastName}
                </p>
                <p>
                  <strong>SSN:</strong>{" "}
                  {formData.claimantInformation.SSN?.replace(/[^-]/g, "•")}
                </p>
              </div>
            </Col>
            <Col>
              <div>
                <p>
                  <strong>Alias(es):</strong>{" "}
                  {formData.claimantInformation.Alias}
                </p>
                <p>
                  <strong>Date of Birth:</strong> {formattedDateOfBirth}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>
                <p>
                  <strong>Claimant Address:</strong>{" "}
                  {formData.claimantInformation.ClaimantAddress}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>
                <p>
                  {" "}
                  <strong>City:</strong> {formData.claimantInformation.city}
                </p>
              </div>
            </Col>
            <Col>
            <Row>
            <Col>
              <div>
                <p>
                  {" "}
                  <strong>State:</strong> {formData.claimantInformation.state}
                </p>
              </div>
            </Col>
            <Col>
              <div>
                <p>
                  {" "}
                  <strong>Zip:</strong> {formData.claimantInformation.zip}
                </p>
              </div>
            </Col>
              </Row>
            </Col>
           
          </Row>
          <Row>
            <Col>
              <div>
                <p>
                  <strong>Claimant Email:</strong>{" "}
                  {formData.claimantInformation.ClaimantEmail}
                </p>
                <p>
                  <strong>Employer Name:</strong>{" "}
                  {formData.claimantInformation.EmployerName}
                </p>
                <p>
                  <strong>Employer Address:</strong>{" "}
                  {formData.claimantInformation.EmployerAddress}
                </p>
              </div>
            </Col>
            <Col>
              <div>
                <p>
                  <strong>Phone:</strong> {formData.claimantInformation.Phone}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>
                <p>
                  {" "}
                  <strong>City:</strong>{" "}
                  {formData.claimantInformation.EmployerCity}
                </p>
              </div>
            </Col>
            <Col>
            <Row>
            <Col>
              <div>
                <p>
                  {" "}
                  <strong>State:</strong>{" "}
                  {formData.claimantInformation.EmployerState}
                </p>
              </div>
            </Col>
            <Col>
              <div>
                <p>
                  {" "}
                  <strong>Zip:</strong>{" "}
                  {formData.claimantInformation.EmployerZip}
                </p>
              </div>
            </Col>
              </Row>        
              </Col>
   
          </Row>
          <Row>
            <Col>
              <div>
                <p>
                  <strong>Employer Phone: </strong>{" "}
                  {formData.claimantInformation.EmployerPhone}
                </p>
              </div>
            </Col>
            <Col>
              <div>
                <p>
                  <strong>Employer Contact:</strong>{" "}
                  {formData.claimantInformation.EmployerContactName}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div>
                <p>
                  <strong>Claimant's Position:</strong>{" "}
                  {formData.claimantInformation.ClaimantPosition}
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div>
                <p>
                  <strong>Date of Inc.:</strong> {formattedDateOfIncident}
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div>
                <p>
                  <strong>Last Worked:</strong> {formattedDateOfLastWorked}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>
                <p>
                  <strong>Nature/Extent of Alleged Injury/Loss:</strong>{" "}
                  {formData.claimantInformation.Nature}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div>
                <p>
                  <strong>Coverage Type: </strong>
                  {formData.claimantInformation.CoverageType}
                </p>
              </div>
            </Col>
            <Col>
              <div>
                <p>
                  <strong>Due Date: </strong>
                  {formattedDueDate}
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            <Col>
              <div>
                <p>
                  <strong>Additional Comments:</strong>{" "}
                  {formData.claimantInformation.AdditionalComments}
                </p>
              </div>
            </Col>
          </Row>
          {uploadedFiles?.claimantInfo?.length > 0 && 
            <Row>
              <Col>
                <div>
                  <p>
                    <strong>Attached file(s):</strong>
                  </p>
                  <ul>
                    {uploadedFiles?.claimantInfo?.map((file, index) => <li key={index}>{file.name}</li>)}
                  </ul>
                </div>
              </Col>
            </Row>
          }
        </Container>
      </div>
      <div className="custom-navbar" style={{ marginTop: "30px" }}>
        <img src={Vector} alt="Info Icon"></img>
        <h1>PRICING</h1>
        <p className="text-color">
        You will receive a confirmation email from Intertel once verification and processing are complete.
        </p>
      </div>
    </div>
  );
};

export default OrderReview;
